<template>
     <div class="brand" v-if="!props.sidebarCollapsed">
        <a-space direction="horizontal">
            <img src="images/logos/LOGO Netplus - By Intercom NEGRO.png" alt="Netplus by Intercom" >
        </a-space>        
    </div>
    <hr v-if="!props.sidebarCollapsed">
    <a-menu :theme="sidebarTheme" :mode="menu_align" v-model:selectedKeys="selectedKeys">
        <MenuItems v-if="route.meta.typeUser != 'Portal'"></MenuItems>
        <MenuItemsCliente v-if="route.meta.typeUser == 'Portal'"></MenuItemsCliente>
    </a-menu>
    <div class="aside-footer">
        <a-space direction="vertical">
            <div align="center"  style="font-size: small">Para mas información visita nuestro sitio web</div>
            <a-button type="primary" href="https://www.netplus.com.ve" block target="_blank">
                WWW.NETPLUS.COM.VE
            </a-button>
        </a-space>
    </div>
</template>
<script setup>
import { ref, onMounted, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import MenuItems from './MenuItems.vue';
import MenuItemsCliente from './MenuItemsClient.vue'
const props = defineProps({
    sidebarCollapsed: {
		type: Boolean,
		default: false,
	},
    sidebarTheme: {
        type: String,
        default: 'light'
    },
    typeMenu: {
        type: String,
        default: "client"
    }
})
const route = useRoute()
const menu_align = ref('inline')
const selectedKeys = ref([1])
onMounted(() => {
    if (props.sidebarCollapsed) {
        menu_align.value = 'vertical'
    } else {
        menu_align.value = 'inline'
    }

})
</script>